import homeView from './index'
import searchView from './search'
import bookView from './book'

import model from './services/model'

export default {
  path: 'autocar',
  component: homeView,
  name: 'Private/Bus',
  redirect: { name: 'Private/Bus/Search' },
  children: [
    {
      path: 'search',
      component: searchView,
      name: 'Private/Bus/Search'
    },
    {
      path: 'book/:Result',
      component: bookView,
      name: 'Private/Bus/Book'
    }
  ],
  beforeEnter (to, from, next) {
    if (!model.initDataLoaded) model.init().then(res => next())
    else next()
  }
}
